import request from "../utils/request";

export const APP_STORE_API = {
    validateCredentials: (data) => {
        return request.post(`/appstore/validate-credentials`, data);
    },

    saveCredentials: (data) => {
        return request.post(`/appstore/save-credentials`, data);
    },

    listApps: (channelId) => {
        return request.get(`/appstore/channels/${channelId}/apps`);
    },

    syncApps: (channelId) => {
        return request.post(`/appstore/channels/${channelId}/apps/sync`);
    },

    listReviews: (data) => {
        return request.post(`/appstore/reviews`, data);
    },

    fetchReviews: (channelId, appId) => {
        return request.get(`/appstore/channels/${channelId}/apps/${appId}/fetch-reviews`);
    },

    replyReview: (reviewId, data) => {
        return request.post(`/appstore/reviews/${reviewId}/reply`, data);
    },

    updateReviewResponse: (reviewId, data) => {
        return request.put(`/appstore/reviews/${reviewId}/response`, data);
    },

    deleteReviewResponse: (reviewId, channelId) => {
        return request.delete(`/appstore/reviews/${reviewId}/response`, { data: { channelId } });
    },

    updateStatus: (reviewId, status, assigneeId) => {
        return request.put(`/appstore/reviews/${reviewId}/status`, { status, assigneeId });
    },
};
